import { Dpr, auto } from "@cloudinary/transformation-builder-sdk/qualifiers/dpr";
export { auto, Dpr };
